import {
  CREATING_WEEKLY_REPORT,
  receiveDocuments,
  receiveDocument
} from './actions'
import { takeEvery, select, put, call } from 'redux-saga/effects'
import { getAccessToken } from '@medeo/user'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from 'pdfmake/build/vfs_fonts.js'
import jwt from 'jsonwebtoken'

function* rootSaga() {
  yield takeEvery(CREATING_WEEKLY_REPORT, createWeeklyReport)
  yield call(loadDocuments)
}

function* loadDocuments() {
  try {
    const accessToken = yield select(getAccessToken)

    const request = yield fetch(`${process.env.FHIR_URL}/documents`, {
      method: 'GET',
      headers: {
        ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
      }
    })
    const documents = yield request.json()
    yield put(receiveDocuments(documents))
  } catch (error) {}
}

function* createWeeklyReport(action) {
  try {
    pdfMake.vfs = pdfFonts.pdfMake.vfs

    const { patient, review } = action.payload
    const accessToken = yield select(getAccessToken)
    const { fhirResourceId } = jwt.decode(accessToken, process.env.SECRET)
    const date = new Date()
    let formData = new FormData()

    let documentReference = {
      status: 'current',
      type: {
        coding: [
          {
            code: '11488-4'
          }
        ],
        text: 'Consult note'
      },
      subject: {
        reference: `Patient/${patient.id}`,
        identifier: patient.id
      },
      author: {
        reference: `Practitioner/${fhirResourceId}`,
        identifier: fhirResourceId
      },
      content: {
        attachment: {
          contentType: 'utf-8',
          language: 'fr',
          data: review
        }
      }
    }

    var docDefinition = {
      content: JSON.stringify(documentReference)
    }
    const pdfGenerator = pdfMake.createPdf(docDefinition)
    const blob = yield getBlob(pdfGenerator)
    formData.append('file', blob, `${patient.id}-review-${date}.pdf`)
    formData.append('patient', patient.id)
    const request = yield fetch(`${process.env.FHIR_URL}/documents`, {
      method: 'POST',
      headers: {
        ...(accessToken != null && {
          Authorization: `Bearer ${accessToken}`
        })
      },
      body: formData
    })
    const response = yield request.json()
    yield put(receiveDocument(response))
  } catch (error) {
    console.log('Report creation error', error)
  }
}

function getBlob(pdfGenerator) {
  return new Promise((resolve, reject) => {
    if (!pdfGenerator) reject('missing pdf generator')

    pdfGenerator.getBlob(blob => {
      resolve(blob)
    })
  })
}
export default rootSaga



// WEBPACK FOOTER //
// ./src/Documents/sagas.js